import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  API_CREATE_SUPPORT_TICKET,
  API_GET_SUPPORT_TICKETS,
} from "../api/supportticket.service";

const initialState = {
  list: [],
  totalCount: 0,
  loadingList: false,
  creating: false,
  listError: null,
  createError: null,
  page: 0,
  limit: 10,
};

export const getSupportTickets = createAsyncThunk(
  "supportTicket/getList",
  async ({ page, limit }, thunkAPI) => {
    try {
      const data = await API_GET_SUPPORT_TICKETS(page, limit);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err);
    }
  }
);

export const createSupportTicket = createAsyncThunk(
  "supportTicket/create",
  async (payload, thunkAPI) => {
    try {
      const data = await API_CREATE_SUPPORT_TICKET(payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err);
    }
  }
);

const supportTicketSlice = createSlice({
  name: "supportTicket",
  initialState,
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setLimit(state, action) {
      state.limit = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSupportTickets.pending, (state) => {
      state.loadingList = true;
      state.listError = null;
    });
    builder.addCase(getSupportTickets.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const data = payload.data || payload;
      const rows =
        data.rows ||
        data.row ||
        data.tickets ||
        payload.rows ||
        payload.row ||
        payload.tickets ||
        [];
      const count = data.count ?? payload.count ?? rows.length;
      state.list = Array.isArray(rows) ? rows : [];
      state.totalCount = Number.isFinite(count) ? count : state.list.length;
      state.loadingList = false;
    });
    builder.addCase(getSupportTickets.rejected, (state, action) => {
      state.loadingList = false;
      state.listError = action.payload || "Failed to load tickets";
    });

    builder.addCase(createSupportTicket.pending, (state) => {
      state.creating = true;
      state.createError = null;
    });
    builder.addCase(createSupportTicket.fulfilled, (state, action) => {
      state.creating = false;
      const payload = action.payload || {};
      const created = payload.data || payload.row || payload.ticket || payload;
      if (created && typeof created === "object") {
        state.list = [created, ...state.list];
        if (state.totalCount) {
          state.totalCount += 1;
        }
      }
    });
    builder.addCase(createSupportTicket.rejected, (state, action) => {
      state.creating = false;
      state.createError = action.payload || "Failed to create ticket";
    });
  },
});

export const { setPage, setLimit } = supportTicketSlice.actions;

export default supportTicketSlice.reducer;
